<template>
  <div class="hz-scrollbar">
    <template v-if="!native" >
      <div ref="wrap" class="hz-scrollbar__wrap" :style="style" @scroll="handleScroll" :class="[wrapClass, gutter ? '' : 'hz-scrollbar__wrap--hidden-default']">
        <div ref="resize" class="hz-scrollbar__view" :class="[viewClass]" :style="viewStyle">
          <slot></slot>
        </div>
      </div>
      <bar :move="moveX" :size="sizeWidth"></bar>
      <bar :move="moveY" :size="sizeHeight" :vertical="true"></bar>
    </template>
    <div v-else ref="wrap" :class="[wrapClass]" class="hz-scrollbar__wrap" :style="style">
        <div ref="resize" class="hz-scrollbar__view" :class="[viewClass]" :style="viewStyle">
          <slot></slot>
        </div>
    </div>
  </div>

</template>

<script>
import { addResizeListener, removeResizeListener } from '../util/resize-event';
import scrollbarWidth from './scrollbar-width';
import { toObject } from './util';
import Bar from './bar';

/* istanbul ignore next */
export default {
  name: 'hz-scrollbar',

  components: { Bar },

  props: {
    native: Boolean,
    wrapStyle: {},
    wrapClass: {},
    viewClass: {},
    viewStyle: {},
    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      default: 'div'
    }
  },

  data() {
    return {
      sizeWidth: '0',
      sizeHeight: '0',
      moveX: 0,
      moveY: 0,
      gutter: scrollbarWidth()
    };
  },

  computed: {
    wrap() {
      return this.$refs.wrap;
    },
    style(){
      let style = this.wrapStyle;
      const gutterWith = `-${this.gutter}px`;
      const gutterStyle = `margin-bottom: ${gutterWith}; margin-right: ${gutterWith};`;

      if (Array.isArray(this.wrapStyle)) {
        style = toObject(this.wrapStyle);
        style.marginRight = style.marginBottom = gutterWith;
      } else if (typeof this.wrapStyle === 'string') {
        style += gutterStyle;
      } else {
        style = gutterStyle;
      }

      return style;
    }
  },
  methods: {
    handleScroll() {
      const wrap = this.wrap;

      this.moveY = ((wrap.scrollTop * 100) / wrap.clientHeight);
      this.moveX = ((wrap.scrollLeft * 100) / wrap.clientWidth);
    },

    update() {
      let heightPercentage, widthPercentage;
      const wrap = this.wrap;
      if (!wrap) return;

      heightPercentage = (wrap.clientHeight * 100 / wrap.scrollHeight);
      widthPercentage = (wrap.clientWidth * 100 / wrap.scrollWidth);

      this.sizeHeight = (heightPercentage < 100) ? (heightPercentage + '%') : '';
      this.sizeWidth = (widthPercentage < 100) ? (widthPercentage + '%') : '';
    }
  },

  mounted() {
    if (this.native) return;
    this.$nextTick(this.update);
    !this.noresize && addResizeListener(this.$refs.resize, this.update);
  },

  beforeDestroy() {
    if (this.native) return;
    !this.noresize && removeResizeListener(this.$refs.resize, this.update);
  }
};
</script>






// WEBPACK FOOTER //
// src/scrollbar/index.vue